import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';

// Stripe
import { getPortalUrl } from '../../config/stripe-config';

// Redux
import { connect } from 'react-redux';

// Icons
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
  
const Billing_Settings = ({
    auth: {
        isPremium
    }
}) =>  {

    const [processing, setProcessing] = useState(false);

    const handle_ManageSubscription = async () => {
        console.log('ABOUT TO REDIRECT TO STRIPE PORTAL');

        setProcessing(true);

        try {
            const stripe_PortalUrl = await getPortalUrl();
            if(stripe_PortalUrl) {
                window.location.href = stripe_PortalUrl;
                window.location.href = stripe_PortalUrl;
                console.log('redirected');
            }
        } catch (error) {
            console.log('FAILED FETCHING PORTAL LINK')
        } finally {
            setProcessing(false);
        }
    }

	return (
        <Fragment>
            {/* Subscriptions Box */}
            {isPremium ? (
                <Fragment>
                    {/* Billing */}
                    <h2 style={{fontSize: '1.5rem', marginBottom: '1rem', fontWeight: 500}}>
                        Your Subscribed!
                    </h2>
                    <p style={{color: 'rgb(156,163,175)', marginBottom: '1.5rem'}}>
                        Click to manage your subscription:
                    </p>
                    <div style={{padding: '1.5rem', background: 'hsla(0,0%,100%,.05)', textAlign: 'center', border: '1px solid rgb(31,41,55)', borderRadius: '.75rem'}}>
                        <button 
                            onClick={handle_ManageSubscription} 
                            style={{boxShadow: '0 0 20px rgba(255,191,0,.3)', background: '#FFFF00', color:'#000', fontWeight: "bold", fontSize: '.875rem', lineHeight: '1.25rem', paddingTop: '.5rem', paddingBottom: '.5rem', paddingLeft: '1rem', paddingRight: '1rem', borderRadius: '14px', cursor: 'pointer'}}
                            disabled={processing}
                        >
                            {processing ? 'Processing...' : 'Manage Subscription'}
                        </button>
                    </div>
                </Fragment>
            ) : (
                <Fragment>
                    {/* Billing */}
                    <h2 style={{fontSize: '1.5rem', marginBottom: '1rem', fontWeight: 500}}>
                        Subscription Plan
                    </h2>
                    <p style={{color: 'rgb(156,163,175)', marginBottom: '1.5rem'}}>
                        Choose a plan to access all features.
                    </p>
                    <div style={{padding: '1.5rem', background: 'hsla(0,0%,100%,.05)', textAlign: 'center', border: '1px solid rgb(31,41,55)', borderRadius: '.75rem'}}>
                        <h3 style={{fontSize: '1.125rem', margin: '0'}}>
                        No Active Subscription
                        </h3>
                        <p style={{fontSize: '15px', color: 'rgb(153,163,175)', marginBottom: '1.5rem', marginTop: '.5rem'}}>
                        Subscribe now to get access to all features
                        </p>
                        <Link to="/checkout">
                            <button style={{boxShadow: '0 0 20px rgba(255,191,0,.3)', background: '#FFFF00', color:'#000', fontWeight: "bold", fontSize: '.875rem', lineHeight: '1.25rem', paddingTop: '.5rem', paddingBottom: '.5rem', paddingLeft: '1rem', paddingRight: '1rem', borderRadius: '14px', cursor: 'pointer'}}>
                                <div style={{display: 'flex', gap: '.5rem', alignItems: 'center'}}>
                                    <LockOutlinedIcon />
                                    Subscribe
                                </div>
                            </button>
                        </Link>
                    </div>
                </Fragment>
            )}
        </Fragment>
	);
}
  
Billing_Settings.propTypes = {
    // Prop type validation for authentication
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    // Mapping the authentication state
    auth: state.auth
});

export default connect(mapStateToProps, { 
    // Connecting actions to the component
})(Billing_Settings);
  